// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._zulpu2gc{gap:var(--ds-space-100,8px)}\n._zulputpp{gap:var(--ds-space-150,9pt)}._19bv1ejb{padding-left:var(--ds-space-300,24px)}\n._1e0c1txw{display:flex}\n._4cvr1h6o{align-items:center}\n._ca0q1ejb{padding-top:var(--ds-space-300,24px)}\n._lcxvglyw{pointer-events:none}\n._n3td1ejb{padding-bottom:var(--ds-space-300,24px)}\n._u5f31ejb{padding-right:var(--ds-space-300,24px)}", ""]);
// Exports
module.exports = exports;
